import React, { useState } from 'react'
import { connect } from 'react-redux'
import { IconWarnTriangle } from '@edulastic/icons'
import {
  roleuser,
  subscriptions,
  testTypes as testTypesConstants,
} from '@edulastic/constants'
import { Radio, Row, Spin } from 'antd'
import { FlexContainer, EduButton, notification } from '@edulastic/common'
import { TitleWrapper } from '@edulastic/common/src/components/MainHeader'
import {
  getRegradeFirebaseDocIdSelector,
  toggleRegradeModalAction,
  getRegradeModalStateSelector,
} from '../TestPage/ducks'
import { InputsWrapper, StyledModal, RegradeWarningMessage } from './styled'
import { updateCorrectTestItemAction } from '../src/actions/classBoard'
import RegradeListenerLcb from './RegradeListenerLcb'
import { getUserOrgId } from '../src/selectors/user'
import { getClassResponseSelector } from '../ClassBoard/ducks'
import { getUserPermissions, getUserRole } from '../../student/Login/ducks'
import { getSubscriptionSelector } from '../Subscription/ducks'

const ACTIONS = {
  SKIP: 'SKIP',
  SCORE: 'SCORE',
  MANUAL: 'MANUAL',
  DISCARD: 'DISCARD',
}

const Group = Radio.Group
const RegradeModal = ({
  districtId,
  toggleRegradeModal,
  modalState,
  updateCorrectItem,
  regradeFirebaseDocId,
  classResponseTest,
  userRole,
  userPermissions,
  testSettingsByDistrictId,
  subscription: { subType } = {},
}) => {
  const { oldTestId, newTestId } = modalState || {}
  const settings = {
    newTestId,
    oldTestId,
    assignmentList: [],
    districtId,
    applyChangesChoice: 'ALL',
    options: {
      removedQuestion: 'DISCARD',
      addedQuestion: 'SKIP',
      testSettings: 'ALL',
      editedQuestion: 'SCORE',
    },
  }

  const [regradeSettings, regradeSettingsChange] = useState(settings)
  const [isInRegrade, setIsInRegrade] = useState(false)

  const onUpdateSettings = (key, value) => {
    const newState = {
      ...regradeSettings,
      options: {
        ...regradeSettings.options,
        [key]: value,
      },
    }
    regradeSettingsChange(newState)
  }

  const onCloseRegardModal = (isChangesDiscarded = false) => {
    toggleRegradeModal(null)
    if (isChangesDiscarded) {
      return notification({
        type: 'warn',
        messageKey: 'publishCorrectItemDiscarded',
      })
    }
  }

  const onApplySettings = () => {
    updateCorrectItem({
      ...modalState.itemData,
      proceedRegrade: true,
      editRegradeChoice: regradeSettings.options.editedQuestion,
      callback: toggleRegradeModal,
    })
    setIsInRegrade(true)
  }

  const showCommonWarning =
    testSettingsByDistrictId[districtId]?.canTeacherAuthorCommonTests &&
    subType === subscriptions.SUBSCRIPTION_SUB_TYPES.ENTERPRISE &&
    userRole === roleuser.TEACHER &&
    (classResponseTest.testType === 'common assessment' ||
      classResponseTest.testType === 'school common assessment') &&
    userPermissions.includes(
      testTypesConstants.TEST_TYPE_PERMISSIONS_MAP[classResponseTest.testType]
    )

  return (
    <StyledModal
      visible
      centered
      title={
        <FlexContainer
          height="36px"
          alignItems="center"
          justifyContent="flex-start"
        >
          <TitleWrapper>REGRADE</TitleWrapper>
        </FlexContainer>
      }
      footer={
        <FlexContainer justifyContent="flex-end">
          <EduButton
            isBlue
            isGhost
            onClick={() => onCloseRegardModal(true)}
            disabled={isInRegrade}
            width="145px"
            height="36px"
          >
            DISCARD CHANGES
          </EduButton>
          <EduButton
            isBlue
            width="145px"
            height="36px"
            data-cy="regrade"
            disabled={isInRegrade}
            onClick={onApplySettings}
          >
            PUBLISH & REGRADE
          </EduButton>
        </FlexContainer>
      }
      width="620px"
    >
      {isInRegrade && <Spin />}
      <InputsWrapper data-cy="edited-items" mt="0px">
        <Row>
          <p>
            The change that has been made to the item requires student responses
            that have been already submitted to be regraded. How would you like
            to proceed?
          </p>
          <br />
        </Row>
        <Group
          defaultValue={regradeSettings.options.editedQuestion}
          onChange={(e) => onUpdateSettings('editedQuestion', e.target.value)}
        >
          <Row key="editedQuestion">
            <Radio data-cy="skip-grading" value={ACTIONS.SKIP}>
              Skip rescoring
            </Radio>
            <Radio data-cy="restore-grading" value={ACTIONS.SCORE}>
              Rescore automatically
            </Radio>
            <Radio data-cy="manual-grading" value={ACTIONS.MANUAL}>
              Mark for manual grading
            </Radio>
          </Row>
        </Group>
      </InputsWrapper>
      {showCommonWarning && (
        <RegradeWarningMessage mt={10}>
          <IconWarnTriangle
            style={{ marginRight: '5px', marginBottom: '-3px' }}
          />
          <span data-cy="regradeWarningMessage">
            You have edited a Common test. Please note that the above changes
            will apply to <b>all assigned classes</b> in the current year, not
            just your classes.
          </span>
        </RegradeWarningMessage>
      )}
      {regradeFirebaseDocId && (
        <RegradeListenerLcb onCloseModal={onCloseRegardModal} />
      )}
    </StyledModal>
  )
}

export default connect(
  (state) => ({
    modalState: getRegradeModalStateSelector(state),
    districtId: getUserOrgId(state),
    regradeFirebaseDocId: getRegradeFirebaseDocIdSelector(state),
    classResponseTest: getClassResponseSelector(state),
    userRole: getUserRole(state),
    userPermissions: getUserPermissions(state),
    testSettingsByDistrictId:
      state.user?.user?.orgData?.testSettingsByDistrictId,
    subscription: getSubscriptionSelector(state),
  }),
  {
    toggleRegradeModal: toggleRegradeModalAction,
    updateCorrectItem: updateCorrectTestItemAction,
  }
)(RegradeModal)
